import { z } from "zod";

export const createInitialVehicleRestitutionPayload = z.object({
  vehicleUuid: z.uuid(),
  phone: z.string(),
  mileage: z.number(),
  isCabinCleaned: z.boolean(),
  isTrunkCleaned: z.boolean(),
  observations: z.string().nullable(),
  departureLocation: z.string(),
  furthestDestination: z.string(),
  pictures: z.array(
    z.object({
      originalFileName: z.string(),
      fileBuffer: z.string(),
    }),
  ),
});

export type CreateInitialVehicleRestitutionPayload = z.infer<
  typeof createInitialVehicleRestitutionPayload
>;
